import ready from "@/scripts/helpers/dom/ready";
import { initUploader as initNewUploader } from "@/modules/uploader";
import { clickTracker } from "@/scripts/helpers/clickTracker";
import cookiePopup from "@/modules/popup-cookie";

window.initUploader = payload => {
  if (window.UPLOADER === undefined) return;

  const hasUploaderNode = !!document.getElementById('uploader-app-node');
  let uploader = null;

  if (!hasUploaderNode) {
    uploader = window.UPLOADER({
      ...payload

    });
  } else {
    uploader = window.UPLOADER({
      ...payload,
      dashboardSelector: '#uploader-app-node',
    });
  }
};

if (window.dropArea) {
  initNewUploader();
};

window.clickTracker = clickTracker;

ready( () => {
  window.clickTracker();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});
